export default {
  plan: 'Plan',
  continue: 'Weiter',
  docs: 'Dokumentation',
  assistViaEmail: 'Wir helfen Ihnen gerne per E-Mail weiter.',
  sendFeedback: 'Bitte senden Sie Ihre Fragen und Ihr Feedback an',
  howDoISignUp: 'Wie registriere ich mich',
  requiredName: 'Name ist ein Pflichtfeld',
  requiredEmail: 'E-Mail ist ein Pflichtfeld',
  requiredPassword: 'Passwort ist ein Pflichtfeld',
  invalidEmail: 'E-Mail ist ungültig',
  minLengthPassword: 'Das Passwort muss mindestens 8 Zeichen enthalten',
  invalidPassword:
    'Das Passwort muss mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
  getStartedWorkoutPlanEmailReminder:
    'Um zu beginnen, besuchen Sie einfach die Fit4me-Webseite und beantworten Sie ein paar kurze Fragen zu Ihren Trainings- und Ernährungsgewohnheiten, Zielen und Ihrem allgemeinen Fitnesslevel. Wir fragen Sie auch nach Ihrer E-Mail-Adresse: bitte stellen Sie sicher, dass Sie diese korrekt eingegeben haben. Sobald wir Ihren individuellen Plan erstellt haben, erhalten Sie einen Download-Link zur App, damit Sie sofort loslegen können.',
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    'Wie erhalte ich meinen individuellen Ernährungs- und Trainingsplan',
  appDownloadAndAccessInstructions:
    'Sie erhalten einen eindeutigen Download-Link, der Sie zum App Store führt, um die App herunterzuladen. Sobald die App auf Ihrem Handy installiert ist, melden Sie sich mit Ihrer E-Mail an. Sie haben während Ihres bezahlten Zeitraums uneingeschränkten Zugriff auf alle Funktionen der App. Bei Problemen mit dem Herunterladen oder Zugriff auf die App, kontaktieren Sie uns bitte unter',
  planReceiveTime: 'Wann erhalte ich meinen individuellen Plan',
  planGenerationDetails:
    'Unsere intelligenten Algorithmen sind sehr präzise und passen den Fitnessplan genau an Ihre Bedürfnisse an. Der eindeutige Download-Link wird unmittelbar nach der Zahlung generiert. Der Plan wird verfügbar, sobald Sie die App über diesen Link herunterladen.',
  freeTrialQuestion: 'Bieten wir immer eine kostenlose Testphase an',
  freeTrialInfo:
    'Bitte beachten Sie, dass eine kostenlose Testphase nur dann angeboten wird, wenn dies auf dem Preisbildschirm vor dem Kauf ausdrücklich angegeben ist. Ist dies nicht der Fall, erwerben Sie das Abonnement ohne kostenlose Testphase.',
  billingQuestion: 'Wie erfolgt die Abrechnung',
  billingInfo:
    'In der Regel bieten wir Abonnements mit automatischer Verlängerung an. Je nach gewählter Option wird Ihr Abonnement am Ende jeder Periode automatisch verlängert.',
  cancelSubscriptionQuestion: 'Kann ich mein Abonnement kündigen',
  cancelSubscriptionInfo:
    'Ihr Abonnement verlängert sich automatisch am Ende jeder Periode, bis Sie es kündigen. Beachten Sie, dass das Löschen der App das Abonnement nicht beendet. Sie können ein Probeabo oder ein Abonnement in den iPhone-Abonnementeinstellungen oder per E-Mail kündigen.',
  noAccessQuestion: 'Ich habe keinen Zugriff mehr auf mein Abonnement – was ist passiert',
  noAccessInfo:
    'Manchmal bieten wir nicht verlängerbare Abonnements an, die nach Ablauf des Abonnementzeitraums (1, 3 oder 6 Monate) enden. Sobald Ihr gewähltes Abonnement abgelaufen ist, verlieren Sie den Zugriff auf die App. Wenn Sie die App nach Ablauf des ursprünglichen Abos weiterhin nutzen möchten, können Sie es jederzeit innerhalb der App oder auf der Fit4me-Webseite erneut erwerben.',
  loginLabel:
    'Melden Sie sich mit Ihrer E-Mail-Adresse an, um auf Ihren persönlichen Abnehmplan zuzugreifen',
  email: 'E-Mail',
  logIn: 'Anmelden',
  name: 'Name',
  gender: {
    label: 'Geschlecht',
    male: 'männlich',
    female: 'weiblich',
  },
  dateOfBirth: 'Geburtsdatum',
  units: {
    label: 'Einheiten',
    kg: 'kg',
    cm: 'cm',
    lbs: 'lbs',
    in: 'in',
    m: 'm',
    ft: 'ft',
  },
  startWeight: 'Ausgangsgewicht',
  height: 'Größe',
  doubleCheckAndRetry: 'Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut',
  wrongEmail: 'Hoppla, falsche E-Mail',
  invalidEmailOrPassword: 'Hoppla, falsche E-Mail oder falsches Passwort',
  avatar: 'Avatar',
  Profile: 'Profil',
  Subscriptions: 'Abonnements',
  loader: 'Ladeindikator',
  billingPeriod: 'Abrechnungszyklus',
  subscriptionPrice: 'Abonnementpreis',
  subscriptionCanceled: 'Ihr Abonnement wurde gekündigt.',
  noFutureCharges: 'Es werden keine weiteren Gebühren anfallen.',
  fullAccessUntilExpires:
    'Sie haben vollen Zugriff auf Fit4Me, bis Ihr aktuelles Abonnement ausläuft.',
  opps: 'Hoppla! <br/>Etwas ist schiefgelaufen.',
  contactUsEmail:
    'Kontaktieren Sie uns unter <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'OK',
  tooExpensive: 'Es ist zu teuer',
  planNotSuitable: 'Der Plan entspricht nicht meinen Bedürfnissen',
  appQualityDisappointment: 'Die Qualität der App entspricht nicht meinen Erwartungen',
  notUsingButMayReturn: 'Ich nutze die App gerade nicht, könnte jedoch später wieder fortfahren',
  goalsAchieved: 'Ich habe meine Ziele bereits erreicht',
  technicalIssues: 'Es gab technische Probleme',
  planTooChallenging: 'Mein persönlicher Plan ist zu anspruchsvoll',
  avoidAutoRenewalFee: 'Ich möchte die automatische Verlängerungsgebühr vermeiden',
  forgotPassword: 'Passwort vergessen?',
  resetPassword: 'Passwort zurücksetzen',
  labelForgot: 'Geben Sie Ihre E-Mail ein, um Ihr Passwort zurückzusetzen',
  placeholderEmail: 'Geben Sie Ihre E-Mail ein',
  recoveryEmailSentAt: 'Wiederherstellungs-E-Mail gesendet am',
  pleaseCheckYourInbox: 'Bitte prüfen Sie Ihren Posteingang (und Spam)',
  sendAgain: 'Erneut senden',
  changeEmail: 'E-Mail ändern',
  checkingYouEmail: 'Ihre E-Mail wird überprüft',
  agreePrivacyPolicy:
    'Indem Sie fortfahren, stimmen Sie unserer <privacy>Datenschutzrichtlinie</privacy> und den <terms>Nutzungsbedingungen</terms> zu',
  emailLogin: 'E-Mail-Anmeldung',
  loginToFit4Me: 'Bei Fit4Me anmelden',
  enter5DigitCode:
    'Geben Sie den 5-stelligen Code ein, der an Ihre <bold>{{email}}</bold>-E-Mail-Adresse gesendet wurde',
  didNotReceiveTheCode: 'Code nicht erhalten?',
  resendCode: 'Code erneut senden',
  contactSupport: 'Oder Sie können <bold>unseren Support kontaktieren</bold>',
  codeResent:
    'Code erneut gesendet! Sie können in <bold>{{seconds}}s</bold> einen neuen Code anfordern',
  emailDoesntMatch: 'E-Mail-Anmeldecode stimmt nicht überein',
  reCheck: 'Überprüfen Sie den Code erneut oder fordern Sie einen neuen an.',
  payments: 'Zahlungen',
  manageSubscription: 'Abonnement verwalten',
  activeBadge: 'Aktiv',
  paymentMethod: 'Zahlungsmethode',
  cancelSubscriptionReason: 'Warum möchten Sie kündigen?',
  nextChargeDate: 'Nächstes Abrechnungsdatum',
  lastChargeDate: 'Letztes Abrechnungsdatum',
  accessUntil: 'Zugriff bis',
  renewSubscription: 'Abonnement verlängern',
  addPaymentMethod: 'Zahlungsmethode hinzufügen',
  noPaymentTitle: 'Keine Zahlungsmethoden',
  noPaymentDescription: 'Fügen Sie eine Zahlungsmethode hinzu, um Ihr Abonnement zu starten',
  canceledStatus: 'Gekündigt',
  yourFeedbackMatters: 'Ihr Feedback ist uns wichtig!',
  specialOffer: 'Bitte warten, wir erstellen ein spezielles Angebot.',
  limitedDeal: 'Zeitlich begrenztes Angebot',
  offerSavings: 'Wir bieten 99 % Ersparnis für 6 Wochen',
  keepWellness: 'Setzen Sie Ihre Wellness-Reise für nur 1 % der regulären Kosten fort!',
  dontMissChance:
    '{{name}}, verpassen Sie nicht die Chance, mit Simples personalisierter Ernährungsberatung fortzufahren. Nach dem 3-monatigen Sparzeitraum beginnt automatisch die reguläre vierteljährliche Abrechnung (79,20 $).',
  keepPremium: 'Premium behalten',
  cancelSubscriptionBtn: 'Abonnement kündigen',
  footerText:
    'Denken Sie daran: Sie können jederzeit vor dem 30. April 2025 kündigen, ohne dass Verlängerungsgebühren anfallen. Ihr 99 % ermäßigter Tarif gilt für die vollen 12 Wochen. Wenn Sie fortfahren, verlängert sich Ihre Mitgliedschaft automatisch zum regulären vierteljährlichen Preis von 79,20 $, sobald der Aktionszeitraum endet. Wir bieten keine Rückerstattungen für teilweise genutzte Abonnementzeiten an. Um Ihre Mitgliedschaft zu verwalten oder zu kündigen, besuchen Sie einfach Ihre Abonnementverwaltungsseite.',
  prosList: {
    analyzed: 'Ihr Profil analysiert',
    noChange: 'Keine Änderung Ihres aktuellen Abrechnungszeitraums',
    after: 'Nach 12 Wochen beträgt Ihr Abonnement 79,20 $ vierteljährlich.',
  },
  gotIt: 'Ok, verstanden',
  weCanceled: 'Wir haben Ihr Abonnement gekündigt',
  yourSubscriptionIsCanceled:
    'Ihr Fit4Me-Abonnement ist jetzt gekündigt. Es fallen keine weiteren Gebühren an. Sie haben weiterhin vollen Zugriff bis zum',
  supportForEditional: 'für weitere Informationen',
  contact: 'Kontaktieren',
  id: 'ID',
  'My account': 'Mein Konto',
  'My Subscriptions': 'Meine Abonnements',
  Support: 'Support',
  FAQ: 'FAQ',
  'Cancel Subscription': 'Abonnement kündigen',
  'Money-Back Policy': 'Geld-zurück-Richtlinie',
  'Privacy Policy': 'Datenschutzerklärung',
  'Terms of Use': 'Nutzungsbedingungen',
  'Meals Recommendations': 'Essensempfehlungen',
  'Contact Us': 'Kontaktieren Sie uns',
}
